import React, { useState } from "react";
import "./ValentineBooking.css";
import adImage from "../assets/valentine.jpeg";
import { Helmet } from "react-helmet";

/* Spinner Overlay */
const SpinnerOverlay = () => (
  <div className="spinner-overlay">
    <div className="spinner"></div>
  </div>
);

export default function ValentineBooking() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    numberOfAdults: 1,
    numberOfChildren: 0,
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.phone || !formData.email) {
      alert("Please fill in all required fields.");
      return;
    }

    if (formData.numberOfAdults < 1) {
      alert("At least one adult is required.");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch("/php/valentine-booking.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (!response.ok) {
        if (response.status === 409) {
          alert(result.error || "Sorry, this event is fully booked.");
        } else if (response.status === 400) {
          alert(result.error || "Please check your form details.");
        } else {
          alert("Something went wrong. Please try again later.");
        }
        return;
      }

      if (result.success) {
        setSubmitted(true);
      } else {
        alert("Unexpected response from server.");
      }
    } catch (err) {
      console.error(err);
      alert("Could not submit booking. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({
      name: "",
      phone: "",
      email: "",
      numberOfAdults: 1,
      numberOfChildren: 0,
    });
  };

  return (
    <div className="page-container">
      {loading && <SpinnerOverlay />}

      <Helmet>
        <title>Valentine Special Booking | LasGidi Restaurant</title>
        <meta
          name="description"
          content="Book your spot for Valentine Special at LasGidi Restaurant. Reserve your table and enjoy an unforgettable experience in Manchester."
        />
        <meta
          name="keywords"
          content="Valentine Special, LasGidi Restaurant, Nigerian Food, Manchester Events, Festive Booking, Table Reservation"
        />
        <meta
          property="og:title"
          content="Valentine Special Booking | LasGidi Restaurant"
        />
        <meta
          property="og:description"
          content="Book your spot for Valentine Special at LasGidi Restaurant. Reserve your table and enjoy an unforgettable experience in Manchester."
        />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="detty-container booking-container heading-container">
        <h1>Valentine Special</h1>
      </div>

      {submitted ? (
        <div className="thank-you">
          <h2>Thank you for booking!</h2>
          <p>We have received your Valentine booking. 🎉</p>
          <p>Hope to see you there!</p>
          <button
            className="submit-button post-review-btn"
            onClick={() => {
              resetForm();
              setSubmitted(false);
            }}
          >
            Back to Form
          </button>
        </div>
      ) : (
        <div className="detty-main">
          <div className="detty-form-container">
            <h2>Book Your Spot Now!</h2>

            <form className="detty-form" onSubmit={handleSubmit}>
              {/* Name */}
              <div className="form-group">
                <label>
                  Name <span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <div className="form-group-input">
                  <label>
                    Phone Number <span className="required">*</span>
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div>
                  <label>
                    Email <span className="required">*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              {/* Adults and Children on the same line */}
              <div className="form-group flex-row">
                <div>
                  <label>
                    Number of Adults <span className="required">*</span>
                  </label>
                  <input
                    type="number"
                    name="numberOfAdults"
                    min="1"
                    value={formData.numberOfAdults}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div>
                  <label>Number of Children</label>
                  <input
                    type="number"
                    name="numberOfChildren"
                    min="0"
                    value={formData.numberOfChildren}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <button
                type="submit"
                className="post-review-btn"
                disabled={loading}
              >
                Book Now
              </button>
            </form>
          </div>

          <div className="detty-ad">
            <img src={adImage} alt="Valentine Booking Promo" />
          </div>
        </div>
      )}
    </div>
  );
}
